// extracted by mini-css-extract-plugin
export default {"container":"agencias_container__5Rxz1","tabla_agencias":"agencias_tabla_agencias__BYGLY","agencia":"agencias_agencia__t06LX"};